<template>
    <div class="modal fade" :class="{ show: isVisible }" tabindex="-1" aria-labelledby="exampleModalLabel"
        style="display: block" aria-modal="true" role="dialog" v-if="isVisible">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0 m-0 justify-content-end">
                    <button class="btn-close" @click="closeModal">
                        <i class="ti ti-x"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label">Search By</label>
                                    <Field as="select" name="search_by" class="form-select" v-model="selectedSearchBy">
                                        <option v-for="option in searchOptions" :key="option.value"
                                            :value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </Field>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-wrap" :class="isNotValid ? 'mb-0' : ''">
                                    <label class="col-form-label">{{ dynamicLabel }}</label>
                                    <Field as="input" name="postcode" class="form-control" v-model="searchValue" @change="handleSearchChange" />
                                </div>
                                <span class="text-danger" v-if="isNotValid">{{ dynamicLabel }} is required</span>
                            </div>
                            <div class="col-md-3 text-end mt-4">
                                <button class="btn btn-primary" @click="handleSearch()">
                                    Search
                                </button>
                            </div>
                        </div>
                        <!-- <div class="row mt-3 justify-content-center">
                            <div class="col-md-6"></div>
                            <div class="col-md-3 text-end">
                                <button class="btn btn-primary" @click="handleSearch()">
                                    Search
                                </button>
                            </div>
                        </div> -->

                        <div class="row mt-3 border-top pt-3" v-if="Object.values(addressData?.company_info || {}).length">
                            <div class="col-md-1">
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="contact-tab-wrap mb-0 px-2">
                                    <ul class="contact-nav nav justify-content-center">
                                        <li class="col-md-2 me-0">
                                            <a href="javascript:;" class="active">Organisation Address</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="table-responsive p-0">
                                <table class="table table-hover table-responsive table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col" class="bg-teal text-white text-center">
                                                Company Name
                                            </th>
                                            <th scope="col" class="bg-teal text-white text-center">
                                                Address Line 1
                                            </th>
                                            <th scope="col" class="bg-teal text-white">
                                                Address Line 2
                                            </th>
                                            <th scope="col" class="bg-teal text-white text-center">
                                                Locality
                                            </th>
                                            <th scope="col" class="bg-teal text-white text-center">
                                                Country
                                            </th>
                                            <th scope="col" class="bg-teal text-white text-center">
                                                Post Code
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr @click="handleOrgData()">
                                            <td class="text-center">{{ addressData?.company_info?.company_name }}
                                            </td>
                                            <td class="text-center">{{ addressData?.company_info?.registered_office_address?.address_line_1 }}
                                            </td>
                                            <td class="text-center">{{ addressData?.company_info?.registered_office_address?.address_line_2 }}
                                            </td>
                                            <td class="text-center">{{ addressData?.company_info?.registered_office_address?.locality }}
                                            </td>
                                            <td class="text-center">{{ addressData?.company_info?.registered_office_address?.country }}
                                            </td>
                                            <td class="text-center">{{ addressData?.company_info?.registered_office_address?.postal_code }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="d-flex justify-content-end mt-3">
                                    <button type="button" class="btn btn-outline-dark"
                                        @click.prevent="handleOrgClick(addressData)">Copy</button>
                                </div>

                                <div v-if="orgClick">
                                    <table class="table table-bordered mt-2">
                                        <tbody>
                                            <tr>
                                                <td><strong>Company Name</strong></td>
                                                <td>{{ addressData?.company_info?.company_name }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Type</strong></td>
                                                <td>{{ addressData?.company_info?.type }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Date of creation</strong></td>
                                                <td>{{ addressData?.company_info?.date_of_creation }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>SIC Codes</strong></td>
                                                <td>{{ addressData?.company_info?.sic_codes?.join(', ') || '' }}</td>
                                            </tr>
                                            <tr v-for="(value, key) in addressData?.company_info?.registered_office_address" :key="key">
                                                <td><strong>{{ formatLabel(key)
                                                }}</strong></td>
                                                <td>{{ value }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-if="noFound" class="d-flex justify-content-center align-items-center">
                           <strong>No Data Found</strong>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ref,
    onMounted,
    watch,
    onUnmounted,
    computed,
    defineEmits
} from "vue";
import {
    useStore
} from "vuex";
import {
    useRouter,
    useRoute
} from "vue-router";
import {
    Form,
    Field,
    ErrorMessage
} from "vee-validate";
import { useToast } from "vue-toast-notification";
import { message } from "ant-design-vue";

export default {
    props: {
        formData: {
            type: Array
        },
        isVisible: {
            type: Boolean,
        },
        selectedSearch: {
            type: String,
            default: "",
        },
        selectedLabel: {
            type: String,
            default: "company_reg_no",
        }
    },
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    setup(props, {
        emit
    }) {
        const store = useStore();
        const toast = useToast();
        const orgClick = ref(false)
        const searchOptions = [{
            value: "company_reg_no",
            text: "Company Reg No.",
        }
        ];
        const searchValue = ref(props.selectedSearch || "");
        const selectedSearchBy = ref(props.selectedLabel || "");
        const addressData = ref({});
        const isNotValid = ref(false);
        const noFound = ref(false)

        // Computed property to determine the dynamic label based on selected search type
        const dynamicLabel = computed(() => {
            if (selectedSearchBy.value === "company_reg_no") {
                return "Company Reg No.";
            }
            return "Company Reg No."; // Default label
        });

        const closeModal = () => {
            addressData.value = {};
            orgClick.value = false;
            noFound.value = false;
            isNotValid.value = false;
            emit("close");
        };

        const handleOrgClick = (addressData) => {
            emit("saveOrgAddress",addressData)
            closeModal()
        }

        const handleSearch = async () => {
            if (searchValue.value === '' || searchValue.value === null) {
                isNotValid.value = true;
                return;
            } else {
                orgClick.value = false;
                isNotValid.value = false;
                const paramsData = {
                    search_type: selectedSearchBy.value,
                    search_value: searchValue.value,
                };
                const response = await store.dispatch(
                    "price/fetchOrgLookupData",
                    paramsData
                );
                if (Object.values(response?.company_info || {}).length) {
                    if (selectedSearchBy.value === "company_reg_no") {
                        noFound.value = false;
                        // addressData.value = response?.company_info?.registered_office_address;
                        addressData.value = response
                    } else {
                        addressData.value = {}
                    }
                } else {
                    noFound.value=true;
                    addressData.value = {}
                    // message.error("No Data found for this Reg no.")
                }
            }
        };

        const handleOrgData = () => {
            orgClick.value = !orgClick.value;
        }

        const handleSearchChange = () =>{
            emit('handleRegChange', searchValue.value)
        }

        // Function to format labels (replaces underscores with spaces and capitalizes)
        const formatLabel = (key) => {
            return key
                .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
                .replace(/_/g, " ") // Replace underscores with spaces
                .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
        };

        watch(
            () => props.selectedSearch,
            (newVal) => {
                searchValue.value = newVal;
            }
        );
        watch(
            () => props.selectedLabel,
            (newLabel) => {
                if (newLabel.toLowerCase() === "company_reg_no") {
                    props.selectedLabel = "company_reg_no"
                    selectedSearchBy.value = "company_reg_no";
                } else {
                    props.selectedLabel = "company_reg_no"
                    selectedSearchBy.value = "company_reg_no";
                }
            }, {
            immediate: true,
        }
        );

        watch(() => props.isVisible,
            () => {
                searchValue.value = props.selectedSearch;
                if(props.isVisible){
                    handleSearch()
                }
            },
            {
                immediate: true,
            }
        );
        watch(() => props.isVisible,
            () => {
                if (props.selectedLabel.toLowerCase() === "company_reg_no") {
                    selectedSearchBy.value = "company_reg_no";
                } else {
                    selectedSearchBy.value = "company_reg_no";
                }
            }, {
            immediate: true,
        }
        );

        // Watch for changes in visibility to apply or remove the backdrop
        watch(
            () => props.isVisible,
            (newValue) => {
                const backdropClass = "modal-backdrop";
                if (newValue) {
                    // Modal is opened
                    document.body.classList.add("modal-open");
                    const backdrop = document.createElement("div");
                    backdrop.className = `${backdropClass} fade show`;
                    document.body.appendChild(backdrop);
                } else {
                    // Modal is closed
                    document.body.classList.remove("modal-open");
                    const backdrop = document.querySelector(`.${backdropClass}`);
                    if (backdrop) {
                        backdrop.remove();
                    }
                }
            }
        );

        // Cleanup on component unmount
        onUnmounted(() => {
            document.body.classList.remove("modal-open");
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
            }
        });

        return {
            addressData,
            store,
            handleSearch,
            searchValue,
            isNotValid,
            closeModal,
            selectedSearchBy,
            dynamicLabel,
            searchOptions,
            handleOrgClick,
            orgClick,
            formatLabel,
            handleOrgData,
            noFound,
            handleSearchChange
        };
    },
};
</script>

<style scoped>
.modal {
    display: block;
    /* Ensure modal is displayed correctly */
}

.row_click {
    cursor: pointer;
}

.table_height {
    max-height: 428px;
}
</style>